import * as React from "react";
import { RouteConfig } from "react-router-config";
import { Route, Switch } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PageLayout from "./layouts/PageLayout";
import Profile from "./pages/Profile/Profile";
import Records from "./pages/Records/Records";

export const routes: RouteConfig[] = [
    {
        path: "/home",
        exact: true,
        component: () : any => <HomePage />,
    },
    {
        path: "/profile",
        component: () : any => <Profile />,
    },
    {
        path: "/records",
        component: () : any => <Records />,
    },
];

export const route = (
    <Switch>
        <Route path="/" component={PageLayout} />
    </Switch>
);
